
import FlyAuth from 'zunzun/flyauth.ui/index.mjs'

const flyauth_div = document.querySelector("div.flyauth");

(async () => {
  try {

    const flyauth = new FlyAuth.SignIn({
      success_path: "/Account"
    })
    console.log(flyauth.element);
    flyauth_div.appendChild(flyauth.element);
    flyauth_div.querySelector('div.step_form_extra').innerHTML += `<p>Don't have an account yet? <a href="/SignUp/index.html">Sign Up</a></p>`
    flyauth_div.querySelector('input[type=text]').focus();

    hide_loading_overlay();
  } catch (e) {
    console.error(e);
  }
})();
